import { render, staticRenderFns } from "./iCardTop.vue?vue&type=template&id=c63027c2&scoped=true&"
import script from "./iCardTop.vue?vue&type=script&lang=js&"
export * from "./iCardTop.vue?vue&type=script&lang=js&"
import style0 from "./iCardTop.vue?vue&type=style&index=0&id=c63027c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63027c2",
  null
  
)

export default component.exports